
import * as types from '../actions/types';

const INITIAL_STATE = {
    customers: [
        {
            dishes: []
        }
    ],
    foodtrucknum: 0,
    checkout: null,
    deliveryTenantId: undefined,
    deliveryTenantName: undefined,
    isInMallDelivery: 0,
    deliveryFee: 0
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.SET_ORDER:
            if (state.checkout && state.restaurantId === action.payload.restaurantId) {
                action.payload.checkout = state.checkout;
            }
            if (state.foodtrucknum && state.restaurantId === action.payload.restaurantId) {
                action.payload.foodtrucknum = state.foodtrucknum;
            }
            if (state.deliveryTenantId && state.restaurantId === action.payload.restaurantId) {
                action.payload.deliveryTenantId = state.deliveryTenantId;
            }
            if (state.deliveryTenantName && state.restaurantId === action.payload.restaurantId) {
                action.payload.deliveryTenantName = state.deliveryTenantName;
            }
            if (state.deliveryFee && state.restaurantId === action.payload.restaurantId) {
                action.payload.deliveryFee = state.deliveryFee;
            }
            if (state.isInMallDelivery && state.restaurantId === action.payload.restaurantId) {
                action.payload.isInMallDelivery = state.isInMallDelivery;
            }
            let order = {}
            Object.assign(order, state, { ...action.payload })
            return order;

        case types.CLEAR_ORDER:
            return INITIAL_STATE;

        default:
            return state;
    }
}